module.exports = __webpack_public_path__ + "static/media/inktober1.c03364e0.jpg";